import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  toggle() {
    this.formTarget.classList.toggle("hidden")
    if (!this.formTarget.classList.contains("hidden")) {
      this.formTarget.querySelector("textarea")?.focus()
    }
  }

  handleSubmit(event) {
    if (event.detail.success) {
      this.hide()
    }
  }

  hide() {
    this.formTarget.classList.add("hidden")
  }
}
